<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <div class="dispatch-table">
          <b-card>
            <div slot="header">
              <span>Registrar</span>
              <a
                href="#"
                class="btn btn-sm btn-info float-right ml-1"
                id="printpagebutton"
                @click="onPrint"
              >
                <i class="fa fa-print"></i> Print
              </a>
              <button
                id="printexport"
                class="btn btn-sm btn-info float-right"
                @click="onexport"
              >
                Export
              </button>
            </div>
            <tr>
              <td>
                <!-- <div class="newButton"> -->
                <b-button
                  variant="primary"
                  @click="
                    $router.push(
                      '/Activity/637471940881413464/new-fleet-registry'
                    )
                  "
                >
                  <i class="fa fa-plus-circle"></i>&nbsp;New Fleet Entry
                </b-button>
                <!-- </div> -->
              </td>
              <td>
                <b-input-group style="margin-left: 10px; margin-bottom: 10px">
                  <b-form-input v-model="filter" placeholder="Search.." />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''"
                      >Clear</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </td>
            </tr>
            <!-- <div class="table-responsive" style="height:300px; overflow:auto;"> -->
            <b-table
              show-empty
              bordered
              responsive="sm"
              stacked="md"
              hover
              small
              striped
              head-variant="light"
              :busy.sync="isBusy"
              :items="items"
              :fields="fields"
              :filter="filter"
              :per-page="perPage"
              :current-page="currentPage"
            >
              <template v-slot:cell(Edit)="data">
                <center>
                  <b-button
                    size="sm"
                    variant="info"
                    class="btn btn-info btn-sm"
                    @click="
                      editFleet(
                        data.item.fleetregistryId,
                        data.item.parkinglane,
                        data.item.branfleetownerId,
                        data.item.plateno,
                        data.item.refdocument
                      )
                    "
                  >
                    <i class="fa fa-pencil-square-o"></i> </b-button
                  >&nbsp;
                </center>
              </template>
              <template v-slot:cell(Remove)="data">
                <center>
                  <b-button
                    size="sm"
                    variant="danger"
                    class="btn btn-danger btn-sm"
                    @click="
                      removefleet(
                        data.item.fleetregistryId,
                        data.item.parkinglane,
                        4
                      )
                    "
                  >
                    <i class="fa fa-trash-o"></i>
                  </b-button>
                </center>
              </template>
              <template slot="arrivaldatetime" slot-scope="data">
                <div>
                  <span>{{
                    data.item.arrivaldatetime
                      | moment("dddd, MMMM Do YYYY, h:mm:ss a")
                  }}</span>
                </div>
              </template>
            </b-table>

            <!-- </div> -->
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              >
              </b-pagination>
            </div>
          </b-card>
        </div>
        <div class="dispatch-list">
          <b-card>
            <div slot="header">
              <span>Registrar</span>
            </div>
            <tr>
              <td>
                <!-- <div class="newButton"> -->
                <b-button
                  variant="primary"
                  @click="
                    $router.push(
                      '/Activity/637471940881413464/new-fleet-registry'
                    )
                  "
                >
                  <i class="fa fa-plus-circle"></i>&nbsp;New Fleet Entry
                </b-button>
                <!-- </div> -->
              </td>
            </tr>
            <b-list-group
              v-for="(item, index) in items"
              :key="`dynlist-${index}`"
              class="shadow"
            >
              <b-list-group-item class="flex-column align-items-start">
                <div class="list-field">
                  <span class="mb-1 dis">Lane No: {{ item.parkinglane }}</span>
                </div>
                <div class="list-field">
                  <span class="mb-1 dis"
                    >Fleet Owner ID: {{ item.branfleetownerId }}</span
                  >
                </div>
                <div class="list-field">
                  <span class="mb-1 dis">Plate No: {{ item.plateno }}</span>
                </div>
                <div class="list-field">
                  <span class="mb-1 dis">Trans Type: {{ item.lanetype }}</span>
                </div>
                <div class="list-field">
                  <span class="mb-1 dis">Barcode: {{ item.scancode }}</span>
                </div>
                <div class="list-field">
                  <span class="mb-1 dis"
                    >Document/Ref No: {{ item.refdocument }}</span
                  >
                </div>
                <div class="list-field">
                  <span class="mb-1 dis"
                    >ADT: {{ DateConvertFooter(item.arrivaldatetime) }}</span
                  >
                </div>
                <div class="row">
                  <div class="col">
                    <div style="text-align: center">
                      <b-button
                        size="sm"
                        variant="info"
                        class="btn btn-primary btn-sm btn-block"
                        @click="
                          editFleet(
                            data.item.fleetregistryId,
                            data.item.parkinglane,
                            data.item.branfleetownerId,
                            data.item.plateno,
                            data.item.refdocument
                          )
                        "
                      >
                        Edit
                      </b-button>
                    </div>
                  </div>
                </div>
                <div class="row" style="margin-top: 5px">
                  <div class="col">
                    <div style="text-align: center">
                      <b-button
                        size="sm"
                        variant="danger"
                        class="btn btn-danger btn-sm btn-block"
                        @click="
                          removefleet(
                            data.item.fleetregistryId,
                            data.item.parkinglane,
                            4
                          )
                        "
                      >
                        Delete
                      </b-button>
                    </div>
                  </div>
                </div>
              </b-list-group-item>
            </b-list-group>

            <!-- </div> -->
            <!-- <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
              >
              </b-pagination>
            </div> -->
          </b-card>
        </div>

        <b-modal
          title="System Message"
          v-model="deleteModal"
          @ok="onDeleteItem"
        >
          Are you sure you want to remove
          <strong>{{ selectedItemLabel }} ?</strong>
        </b-modal>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import api from "../../../services/api";
import JSONToCSVConvertor from "../../../services/JSONToCSVConvertor.js";
import moment from "moment";
import axios from "axios";
import querystring from "query-string";
export default {
  data: function () {
    return {
      deleteModal: false,
      selectedItem: {},
      selectedItemLabel: "",

      perPage: this.$store.getters.perPage,
      totalItem: 0,
      currentPage: 1,
      isBusy: false,
      filter: null,
      fields: [
        {
          key: "Edit",
          label: "Edit",
          class: "action-button",
        },
        {
          key: "Remove",
          label: "Remove",
          class: "action-button",
        },
        // {
        //   key: "fleetregistryId",
        //   label: "Registrar ID",
        //   sortable: true
        // },
        {
          key: "parkinglane",
          label: "Lane Number",
          sortable: true,
        },
        {
          key: "branfleetownerId",
          label: "Fleet Owner Id",
          sortable: false,
        },
        {
          key: "plateno",
          label: "Plate Number",
          sortable: true,
        },

        {
          key: "lanetype",
          label: "Trans Type",
          sortable: true,
        },
        {
          key: "scancode",
          label: "Barcode",
          sortable: true,
        },
        {
          key: "refdocument",
          label: "Document",
          sortable: true,
        },
        {
          key: "arrivaldatetime",
          label: "ADT",
          sortable: true,
          formatter: "DateConvertFooter",
        },
      ],
      items: null,

      form: {
        fleetregistryId:
          this.$route.params.id == undefined ? "" : this.$route.params.id,

        branfleetownerId: "",
        regtype: "",
        plateno: "",

        licenseno: "",
        parkinglane: "",
        arrivaldatetime: "",
        scancode: "",

        refdocument: "",
        remarks: "",
        ismailed: 0,
        brancode: this.$store.getters.selectedWarehouse,
        created_by:
          this.$store.getters.user.firstname +
          " " +
          this.$store.getters.user.lastname,
        create_date: "",
        isdelete: 0,
      },
    };
  },

  computed: {
    filter() {
      this.currentPage = 1;
      this.totalrows = this.items.length;
    },

    rows() {
      return this.items.length;
    },
  },

  methods: {
    onPrint: function () {
      // this.isHidden = true;
      var printButton = document.getElementById("printpagebutton");
      var printExport = document.getElementById("printexport");
      var breadView = document.getElementById("breadview");
      //Set the print button visibility to 'hidden'
      printButton.style.visibility = "hidden";
      printExport.style.visibility = "hidden";
      breadView.style.visibility = "hidden";
      //Print the page content
      window.print();
      printButton.style.visibility = "visible";
      printExport.style.visibility = "visible";
      breadView.style.visibility = "visible";
    },

    onexport: function () {
      JSONToCSVConvertor(this.items, "Fleet Registry List", true);
    },

    DateConvertFooter(date) {
      if (date !== null) {
        var newDate = date;
        newDate =
          newDate[1] + "-" + newDate[2].substring(0, 2) + "-" + newDate[0];
        return moment(date).format("MM-DD-YYYY, h:mm a");
      }
    },

    initTable() {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      this.isBusy = true;
      var self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleet-registry-registry?brancode=" +
            self.$store.state.selectedWarehouse
        )
        .then((resp) => {
          self.items = resp.data;
          self.totalInbound = resp.data.totalItem;
          console.log(resp.data);
          self.$store.commit("setLoading", false);
          self.isBusy = false;
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    onPageSelect(page) {
      this.isBusy = true;

      let self = this;
      self.$store.commit("setLoading", true);
      axios
        .get(
          this.$store.state.IFMSURLlocal +
            "get-fleet-registry-warehouse?brancode=" +
            self.$store.state.selectedWarehouse
        )
        .then((resp) => {
          self.items = resp.data;
          self.totalItem = resp.data.totalItem;

          self.$store.commit("setLoading", false);
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
        })
        .catch((err) => {
          // Here we could override the busy state, setting isBusy to false
          self.isBusy = false;
          api.httpMsg(self, err.status, err.data);
          self.$store.commit("setLoading", false);
          // Returning an empty array, allows table to correctly handle busy state in case of error
          return [];
        });
    },

    onSelecteItemToDelete: function (param) {
      this.selectedItem = param;
      this.selectedItemLabel = this.selectedItem.fleetregistryId;
      this.deleteModal = true;
    },

    onDeleteItem: function () {
      this.$store.commit("setLoading", true);
      api.instance
        .delete(
          this.$store.state.IFMSURLlocal +
            "remove-fleet-registry?fleetregistryId=" +
            this.selectedItem.fleetregistryId
        )
        .then((resp) => {
          this.initTable();
          this.deleteModal = false;
          this.$store.commit("setLoading", false);
        })
        .catch((err) => {
          api.httpMsg(self, err.status, err.data);
          this.$store.commit("setLoading", false);
        });
    },

    editFleet(id, parking, fleetowner, plate, doc) {
      (this.$store.state.parkinglane = parking),
        (this.$store.state.fleetowner = fleetowner),
        (this.$store.state.plateNo = plate),
        (this.$store.state.refDoc = doc),
        this.$router.push(
          "/Activity/637471940881413464/modify-fleet-registry/" + id
        );
    },

    removefleet(id, parking, action) {
      this.form.fleetregistryId = id;
      this.form.isdelete = 1;
      this.form.parkinglane = parking;
      var data = querystring.stringify(this.form);
      if (confirm("Are you sure you want to delete?")) {
        axios
          .post(
            this.$store.state.IFMSURLlocal +
              "IFMSDelete?action=" +
              action,
            data,
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then(() => {
            this.initTable();
          })
          .catch((error) => console.log(error));
      }
    },
  },

  created: function () {
    this.initTable();
  },
};
</script>